// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nC0T","title":"styles_title__1byg_"};